const landingPageNordBg = {
    // Main hero section
    hero: {
        title: "Вашият интернет е <span class='text-red-500'>не е защитен!</span>\nЗащитете връзката си\nднес с <span class='text-blue-600'>NordVPN!</span>",
        subtitle: "Добре дошли в свят, където вашата онлайн поверителност е от първостепенно значение, а вашият цифров живот е ваш. Открийте как NordVPN може да защити всеки ваш клик и натискане на клавиши",
        primaryButton: "Защитете го сега",
        secondaryButton: "Купете NordVPN",
        noCardRequired: "Не се изисква карта",
        moneyBackGuarantee: "30-дневна гаранция за връщане на парите"
    },

    // Stats section
    stats: {
        vpnServers: "VPN сървъри",
        usersWorldwide: "Потребители по света",
        countries: "Страни"
    },

    // Why Us section
    whyUs: {
        sectionTitle: "ЗАЩО НИE?",
        title: "Защо потребителите<br />избират NordVPN?",
        subtitle: "NordVPN е надежден доставчик на VPN с набор от функции, които подобряват вашата сигурност, поверителност и свобода онлайн.",
        features: {
            onlineSecurity: "Онлайн сигурност",
            hideYourIp: "Скрийте вашия IP",
            fastestVpn: "Най-бърз VPN",
            globalCoverage: "Глобално покритие",
            multipleDevices: "Множество устройства",
            noUserTracking: "Без проследяване на потребители"
        },
        button: "Започнете сега"
    },

    // Trusted section
    trusted: {
        sectionTitle: "НА НАС СЕ ДОВЕРЯВАТ",
        title: "Присъединете се към милионите, които се доверяват на NordVPN<br class='hidden lg:block'> за защита на тяхната сигурност",
        testimonials: [
            {
                name: "Alch3m1st",
                handle: "@Alch3m1s7",
                text: "@NordVPN новият meshnet е изумително невероятно технологично произведение 🚀, с неограничени бездънни случаи на употреба. Бог да ви благослови всички! 🙌",
                avatar: "male"
            },
            {
                name: "Nathan Corliss",
                handle: "@MrNathanCorliss",
                text: "Това е напълно непоискана похвала, <span class='text-blue-600'>@NordVPN</span>, е много полезен като рекламодател, който тества реклами за търсене, и като човек, който работи отвсякъде и трябва да се увери, че има безопасна интернет връзка. Отлична стойност. Толкова лесен за използване, че наистина го използвам. Продължавайте добрата работа.",
                avatar: "male1"
            },
            {
                name: "Pedro",
                handle: "@PedroTheKiwi",
                text: "Използвам NordVPN и другите им продукти през последните 4 години. Абсолютно изключителен продукт и услуга",
                avatar: "male2"
            }
        ],
        button: "Купете NordVPN"
    },

    // How to use section
    howToUse: {
        sectionTitle: "КАК ДА ИЗПОЛЗВАТЕ",
        title: "Кликнете, свържете се, останете защитени",
        subtitle: "Как да използвате NordVPN в 3 лесни стъпки.",
        steps: {
            step1: {
                title: "Купете NordVPN",
                description: "<span style='color: #3E5FFF'>Изберете плана, който ви подхожда</span> и <span style='color: #3E5FFF'>създайте акаунт.</span>"
            },
            step2: {
                title: "Изтеглете приложението",
                description: "Изтеглете <span style='color: #3E5FFF'>NordVPN приложението</span> за вашето устройство."
            },
            step3: {
                title: "Свържете се с VPN",
                description: "Изберете VPN сървър и се свържете."
            }
        },
        button: "Купете NordVPN"
    },

    // Pricing section
    pricing: {
        sectionTitle: "ЦЕНИ",
        title: "Вземете NordVPN чрез директен дебит от оператора днес!",
        subtitle: "Вашият цифров живот защитен за<br />BGN 24.00 с ДДС на месец",
        planName: "Стандартен",
        price: "BGN 0.8",
        priceUnit: "/ден",
        vatNotice: "ДДС може да се прилага",
        features: [
            "Сигурен и високоскоростен VPN",
            "Threat Protection Pro™: Защита срещу злонамерен софтуер и разширена онлайн сигурност",
            "Threat Protection Pro™: Блокиране на реклами и тракери"
        ],
        button: "Купете NordVPN",
        guarantees: {
            moneyBack: "30-дневна гаранция за връщане на парите",
            noCard: "Не се изисква карта"
        }
    },

    // Hassle-free section
    hassleFree: {
        title: "Безпроблемна настройка и 30-дневна гаранция за връщане на парите",
        subtitle: "Насладете се на пълен достъп до премиум VPN без никакви рискове. Ако не сте 100% доволни, уведомете ни в рамките на 30 дни от закупуването на NordVPN и получете пълно възстановяване.",
        button: "Опитайте NordVPN без риск"
    },

    // FAQ section
    faq: {
        sectionTitle: "ЧЗВ",
        title: "Често задавани въпроси",
        questions: [
            {
                question: "Как работи процесът на директен дебит от оператора?",
                answer: "Добре дошли в свят, където вашата поверителност онлайн е от първостепенно значение, а вашият цифров живот е ваш. Открийте как NordVPN може да защити всеки клик и натискане на клавиши."
            },
            {
                question: "Законно ли е да използвам NordVPN?",
                answer: "Да, законно е да използвате VPN в повечето страни. Въпреки това, вашата отговорност е да се уверите, че не участвате в незаконни дейности, докато използвате VPN."
            },
            {
                question: "Защо трябва да плащам за VPN услуга?",
                answer: "Безплатните VPN често имат ограничения, като по-бавни скорости, ограничения на данните и по-малко местоположения на сървъри. Платените VPN като NordVPN предлагат по-надежда и сигурна услуга с неограничена честотна лента и голяма мрежа от сървъри."
            },
            {
                question: "Мога ли да използвам NordVPN, докато пътувам в чужбина?",
                answer: "Да, можете да използвате NordVPN за достъп до любимото си съдържание и услуги от всякъде по света. Това ви помага да заобиколите географските ограничения и цензурата."
            },
            {
                question: "Какви устройства поддържа NordVPN?",
                answer: "NordVPN поддържа широк спектър от устройства, включително Windows, macOS, iOS, Android, Linux и други. Можете да защитите до 6 устройства с една абонаментна услуга."
            },
            {
                question: "Как да се свържа с поддръжката на NordVPN?",
                answer: "Можете да се свържете с нашия екип за поддръжка на клиенти 24/7 чрез чат на живо или имейл. Винаги сме тук, за да ви помогнем с всякакви въпроси или проблеми, които може да имате."
            }
        ]
    },

    // Footer section
    footer: {
        links: {
            privacyPolicy: "Политика за поверителност",
            termsOfUse: "Условия за ползване",
            cookiePolicy: "Политика за бисквитки",
            dpi: "DPI",
            contact: "Контакт"
        }
    },

    // Step forms
    steps: {
        moneyBackGuarantee: "30-дневна гаранция за връщане на парите"
    }
};

export default landingPageNordBg; 